import { createContext, useContext, useEffect, useState, type CSSProperties, type ReactNode } from 'react';

type SiteAssets = Record<string, string>;
const SiteAssetsContext = createContext<SiteAssets>({});

export function SiteAssetsProvider({ children }: { children: ReactNode }) {
  const [assets, setAssets] = useState<SiteAssets>({});
  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/site-assets', { credentials: 'include', signal: controller.signal })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => { if (data?.assets) setAssets(data.assets); })
      .catch(() => undefined);
    return () => controller.abort();
  }, []);
  return <SiteAssetsContext.Provider value={assets}>{children}</SiteAssetsContext.Provider>;
}

export function useSiteAsset(key: string) {
  return useContext(SiteAssetsContext)[key] || '';
}

export function siteAssetBackground(image: string): CSSProperties | undefined {
  return image ? { '--site-hero-image': `url(${image})` } as CSSProperties : undefined;
}
